import React, { useEffect } from 'react';
import './LeoMeaning.scss';
//import Aos from 'aos';
import 'aos/dist/aos.css';

const LeoMeaning = () => {
    return (
        <div className="leomeaning-body">
            <div className="leomeaning-body-container">
                <div className="col-md-123"><h className="contactus-heading" data-aos="fade-down">What is&nbsp;<span className="sub-contactus-heading">Leo?</span></h></div>
                <div className="col-md-12 row d-flex justify-content-center">
                    <div className="col-lg-6 col-md-12  justify-content-center pt-0 img-flag-container" data-aos="flip-left" >
                        <img src="/assets/images/LCCM-Flag-shadow.png" alt="Leo flag" className="img-fluid pt-0 img-flag" />
                    </div>
                    <div className="col-md-6 px-0 ">

                        <div className="timeline">
                            <div className="timeline__event animated fadeInUp delay-2s timeline__event--type2">
                                <div className="timeline__event__icon " data-aos="zoom-in">
                                    {/* <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 841.9 595.3">
                            <text x="50%" y="60%" text-anchor="middle" className="text1 text-white"  >
                                L
                            </text>
                        </svg> */}
                                    <div className="wrapper1">
                                        <h1>L</h1>
                                    </div>
                                    {/* <article>
                            <h1>L</h1>
                        </article> */}


                                </div>

                                <div className="timeline__event__content" data-aos="fade-left">
                                    <div className="timeline__event__title">
                                        Leadership
                                    </div>
                                    <div className="timeline__event__description">
                                        <p>To develop Leadership qualities and lead with integrity while making the society a better place and inspiring everyone to be leaders</p>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline__event animated fadeInUp delay-2s timeline__event--type2">
                                <div className="timeline__event__icon" data-aos="zoom-in">
                                    {/* <article>
                            <h1>E</h1>
                        </article> */}
                                    <div className="wrapper1">
                                        <h1>E</h1>
                                    </div>

                                </div>

                                <div className="timeline__event__content" data-aos="fade-left">
                                    <div className="timeline__event__title">
                                        Experience
                                    </div>
                                    <div className="timeline__event__description">
                                        <p>To learn with Experience and move forward while volunteering and interacting with new people to make friendships and expand skills </p>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline__event animated fadeInUp delay-2s timeline__event--type2">
                                <div className="timeline__event__icon" data-aos="zoom-in">
                                    <div className="wrapper1">
                                        <h1>O</h1>
                                    </div>

                                </div>

                                <div className="timeline__event__content" data-aos="fade-left">
                                    <div className="timeline__event__title">
                                        Opportunity
                                    </div>
                                    <div className="timeline__event__description">
                                        <p>To create the Opportunity and serve the community while improving ourselves and striving to grow</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default LeoMeaning;



